/* ============================================================
   Euphree Support Portal — euphree-support-portal.js
   HubSpot Embedded Forms — one per form type
   Portal ID: 48274438
   ============================================================ */

(function () {
  'use strict';

  // ── Config ─────────────────────────────────────────────────
  const PORTAL_ID = '48274438';

  // HubSpot Form IDs — one per form type
  // Add remaining form IDs as they are created in HubSpot.
  //
  // Each HubSpot form should be configured with these hidden fields
  // (set HubSpot "Default value" so the values are baked in per form):
  //
  //   form key       submitter_type  ticket subject (hidden default)
  //   ─────────────  ──────────────  ─────────────────────────────────
  //   dtc-inquiry    Customer        Customer: Product Inquiry
  //   dtc-ship       Customer        Customer: Shipping Issue
  //   dtc-bike       Customer        Customer: Bike Problem
  //   dtc-pq         Customer        Customer: Product Question
  //   dlr-ship       Dealer          Dealer: Shipping Damage
  //   dlr-floor      Dealer          Dealer: Floor Bike Issue
  //   dlr-cust       Dealer          Dealer: Customer Warranty
  //
  // Plus a visible Ticket "description" / content field for the user's
  // message, and HubSpot's "Connect to help desk" toggle enabled so a
  // ticket auto-creates on submission.
  const HS_FORMS = {
    'dtc-inquiry': 'e23dbba5-ebf6-4c0d-b476-8af056548504',
    'dtc-ship':    'da8dd000-da6d-4f22-abaf-7e1a7ad3e15d',
    'dtc-bike':    '4889126d-84aa-4f4b-bf45-a6cdf8099a3d',
    'dtc-pq':      '82b36e87-9807-4f8c-bbc6-465eaa6955ce',
    'dlr-ship':    '55a1eb29-7078-479e-b10d-c842ab924893',
    'dlr-floor':   'c01e488e-235e-45f9-84ba-44ee5f630297',
    'dlr-cust':    '7bac2ccc-dc41-4a73-9619-0d686bef82bc',
  };

  // Container ID for each form type's HubSpot embed div
  const HS_CONTAINERS = {
    'dtc-inquiry': 'eu-hs-dtc-inquiry',
    'dtc-ship':    'eu-hs-dtc-ship',
    'dtc-bike':    'eu-hs-dtc-bike',
    'dtc-pq':      'eu-hs-dtc-pq',
    'dlr-ship':    'eu-hs-dlr-ship',
    'dlr-floor':   'eu-hs-dlr-floor',
    'dlr-cust':    'eu-hs-dlr-cust',
  };

  // Track which form types have already been rendered, to avoid double-render
  const rendered = {};

  // Load HubSpot v2 forms script — supports dynamic hbspt.forms.create()
  function loadHsScript(cb) {
    if (window.hbspt && window.hbspt.forms) { cb(); return; }
    const existing = document.getElementById('hs-forms-script');
    if (existing) {
      existing.addEventListener('load', cb);
      return;
    }
    const s = document.createElement('script');
    s.id      = 'hs-forms-script';
    s.charset = 'utf-8';
    s.type    = 'text/javascript';
    s.src     = '//js.hsforms.net/forms/embed/v2.js';
    s.onload  = cb;
    document.head.appendChild(s);
  }

  // Embed a HubSpot form into its target container by form type
  function embedHsForm(formType) {
    const formId      = HS_FORMS[formType];
    const containerId = HS_CONTAINERS[formType];
    const container   = document.getElementById(containerId);
    if (!container) return;

    if (!formId) {
      container.innerHTML = '<p style="color:var(--eu-red);padding:16px 0">' +
        'Form not yet configured for this submission type. Please call us at (866) 729-8075.</p>';
      return;
    }

    if (rendered[formType]) return;
    rendered[formType] = true;
    container.innerHTML = '';

    loadHsScript(function () {
      if (!window.hbspt || !window.hbspt.forms) return;
      window.hbspt.forms.create({
        region: 'na1',
        portalId: PORTAL_ID,
        formId: formId,
        target: '#' + containerId
      });
    });
  }

  // ── Screen navigation ──────────────────────────────────────
  window.euGo = function (id) {
    document.querySelectorAll('.eu-screen').forEach(s => s.classList.remove('eu-active'));
    const target = document.getElementById(id);
    if (target) {
      target.classList.add('eu-active');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // ── Audience selection ─────────────────────────────────────
  window.euSetAud = function (aud) {
    euGo(aud === 'dtc' ? 'eu-dtc1' : 'eu-dlr2');
  };

  // ── DTC Step 1: Category ───────────────────────────────────
  window.euPickDtc = function (type) {
    document.querySelectorAll('#eu-dtc1 .eu-issue-btn').forEach(b => b.classList.remove('eu-sel'));
    const btn = document.getElementById('eu-dtc-' + type);
    if (btn) btn.classList.add('eu-sel');
    setTimeout(function () {
      if (type === 'inquiry') {
        embedHsForm('dtc-inquiry');
        euGo('eu-dtc2a');
      } else {
        euGo('eu-dtc2b');
      }
    }, 200);
  };

  // ── DTC Step 2b: Sub-category ──────────────────────────────
  window.euPickSub = function (type) {
    document.querySelectorAll('#eu-dtc2b .eu-issue-btn').forEach(b => b.classList.remove('eu-sel'));
    const btn = document.getElementById('eu-sub-' + type);
    if (btn) btn.classList.add('eu-sel');
    setTimeout(function () {
      const screenMap = { ship: 'eu-dtc3a', bike: 'eu-dtc3b', pq: 'eu-dtc3c' };
      const formMap   = { ship: 'dtc-ship', bike: 'dtc-bike', pq: 'dtc-pq' };
      const formType  = formMap[type];
      const screenId  = screenMap[type];
      if (formType) embedHsForm(formType);
      euGo(screenId || 'eu-dtc2b');
    }, 200);
  };

  // ── Dealer Step 2: Issue type ──────────────────────────────
  window.euPickDlr = function (type) {
    document.querySelectorAll('#eu-dlr2 .eu-issue-btn').forEach(b => b.classList.remove('eu-sel'));
    const btn = document.getElementById('eu-dlr-' + type);
    if (btn) btn.classList.add('eu-sel');
    setTimeout(function () {
      const screenMap = { dship: 'eu-dlr3a', floor: 'eu-dlr3b', custbike: 'eu-dlr3c' };
      const formMap   = { dship: 'dlr-ship', floor: 'dlr-floor', custbike: 'dlr-cust' };
      const formType  = formMap[type];
      const screenId  = screenMap[type];
      if (formType) embedHsForm(formType);
      euGo(screenId || 'eu-dlr2');
    }, 200);
  };

  // ── Reset ──────────────────────────────────────────────────
  window.euReset = function () {
    document.querySelectorAll('.eu-issue-btn').forEach(b => b.classList.remove('eu-sel'));
    euGo('eu-s0');
  };

})();
